import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import AlbumCard from './AlbumCard'

import * as shapes from '../../constant/shapes'

import { getArtist as getArtistAction } from './artistActions'
import * as selectors from './artistSelectors'
import appConst from '../../constant/appConst'
import { Link } from 'react-router'
import TrackList from '../../components/tracklist/TrackList'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import Loader from '../../components/loader/Loader'
import redirectToApp from '../../utils/redirectToApp'
import { Helmet } from 'react-helmet'
import * as playerSelectors from '../../components/miniPlayer/miniPlayerSelectors'
import * as constant from '../../components/miniPlayer/AudioPlayer/playerConstants'
import ShareComponent from '../../components/share/ShareComponent'
import ReadMoreComponent from "../../components/ReadMoreComponent"
import GTMController from "../../utils/kpi/GTMController"
import cx from "classnames"

const fields = [{
	type: 'number',
	render: (track, index) => <span>{index + 1}</span>
},{
	type: 'name',
	render: track => `${track.title}${track.version ? ` (${track.version})` : ''}`
}, {
	type: 'album',
	render: track => <Link to={`/album/${track.albumId}`}>{track.album}</Link>
}, {
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

class ArtistPage extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			defaultCardHeight: null,
			defaultImageHeight: null
		}
		this.setCardsSizes = this.setCardsSizes.bind(this)
		this.onResize = this.onResize.bind(this)
	}

	componentWillMount() {
		const { id, getArtist } = this.props
		getArtist(id, 0, 8)
	}

	componentDidMount() {
		this.setCardsSizes()
		window.addEventListener('resize', this.onResize, false)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
		window.removeEventListener('resize', this.onResize, false)
	}

	componentWillReceiveProps(nextProps) {
		const { id } = this.props
		if (id !== nextProps.id) {
			this.props.clearPlayqueue()
		}
		if (nextProps.infos.name) {
			GTMController.pushArtistPageEvent(nextProps.infos.name)
		}
	}

	onResize() {
		this.setCardsSizes()
	}

	setCardsSizes() {
		const metaHeight = 54
		const albums = document.querySelectorAll('.albums-generic-grid-list > .item')
		if (albums) {
			const firstAlbum = albums[0]
			if (firstAlbum) {
				const cardWith = +firstAlbum.clientWidth
				this.setState({
					defaultImageHeight: cardWith - 2, // 1px border
					defaultCardHeight: cardWith + metaHeight
				})
			}
		}
	}

	render() {
		const { id, infos, albums, isCurrentTrack, isPlaying } = this.props
		const { intl } = this.context
		const showDisplayFull = (infos.description || '').length > appConst.descriptionMaxLength

		return (
			<Loader>
				<div className="page page--artist">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.artist" }, { artistName: infos.name })}</title>
					</Helmet>
					<div className="page__background page__background--artist" style={{ backgroundImage: `url(${infos.image})` }} />

					<div className="page__container">

						{/* HEADING BLOC */}
						<div className="heading">
							{infos.image ?
								<div
									className="heading__cover heading__cover--artist"
									style={{ backgroundImage: `url(${infos.image})` }}
									title={infos.name}
								/>
							:
								<div className="heading__cover heading__cover--artist heading__cover--artist--empty pct pct-artist" />
							}
							<div className="heading__container heading__container--artist">
								<h1 className="heading__title heading__title--artist">{infos.name}</h1>
								<p className="heading__infos heading__infos--artist">
									{intl.formatMessage({ id: 'infos.diskCount' }, { count: `${infos.nbDisques}` })}
								</p>
								<div className="heading__buttons">
									<a
										className="heading__button pct pct-play"
										onClick={() => redirectToApp('artist', id)}
									>
										{intl.formatMessage({ id: 'buttons.listen' })}
									</a>
									<ShareComponent GTMCopyEvent={GTMController.EVENTS.ARTIST_SHARE}/>
								</div>
							</div>
						</div>

						{/* INFOS BLOC */}
						{(infos.description) &&
							<div className="infos infos--artist">
								<h2 className="infos__title">{intl.formatMessage({ id: 'aside.title' })}</h2>
								<div className={cx('infos__container', 'infos__container--artist', { 'infos__container--long': showDisplayFull})}>
									<p {...{ className: 'infos__excerpt' }}
										dangerouslySetInnerHTML={{ __html: (infos.description ? `${infos.description}` : '').nl2br() }}
									/>
									<ReadMoreComponent id={id} type={"artist"} />
								</div>
							</div>
						}

						{/* TOP TRACKLIST BLOC */}
						{infos.hasTopTracks &&
							<div className="tracklist tracklist--artist">
								<h2 className="tracklist__title">{intl.formatMessage({ id: 'tracklist.title.artist' })}</h2>
								<TrackList
									fields={fields}
									GTMPlayEvent={GTMController.EVENTS.ARTIST_TRACK_PLAY}
									listContainerClassName="tracklist__container tracklist__container--artist"
									listClassName="tracklist__tracks"
								/>
							</div>
						}

						{/* GRID BLOC */}
						<div className="grid">
							<h2 className="grid__title">{intl.formatMessage({ id: 'tracklist.title.artist_albums' })}</h2>
							<div className="grid__container">
								{albums.map(album => <AlbumCard
									forceCardHeight={this.state.defaultCardHeight}
									forceImageHeight={this.state.defaultImageHeight}
									key={`album-${album.id}`}
									GTMPlayEvent={GTMController.EVENTS.ARTIST_ALBUM_PLAY}
									current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, album.id)}
									playing={isPlaying}
									album={album}
								/>)}
							</div>
							{infos.nbDisques > 8 &&
								<a
									className="grid__button pct pct-add"
									onClick={() => redirectToApp('artist', id)}
								>
									{intl.formatMessage({ id: 'buttons.morealbums' })}
								</a>
							}
						</div>
					</div>
				</div>
			</Loader>
		)
	}
}

ArtistPage.propTypes = {
	id: PropTypes.string,
	infos: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		nbDisques: PropTypes.number,
		description: PropTypes.string,
		image: PropTypes.string,
		hasTopTracks: PropTypes.bool
	}),
	albums: PropTypes.arrayOf(shapes.albumCard),
	isCurrentTrack: PropTypes.func,
	isPlaying: PropTypes.bool,
	getArtist: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

ArtistPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	infos: selectors.getArtistInfos(state),
	albums: selectors.getArtistAlbums(state),
	isCurrentTrack: playerSelectors.isCurrentTrack(state),
	isPlaying: playerSelectors.isPlaying(state)
})

const actions = {
	getArtist: getArtistAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(ArtistPage)



// WEBPACK FOOTER //
// ./src/pages/artist/ArtistPage.jsx